var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJacz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.35 61.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PRPO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.37,59.61a11.17,11.17,0,0,1-9.8,0c-4.36-1.94-6.61-2.47-10.78-.29-3,1.57-7.35,1.94-10,.54C30,57.41,27,57.22,23.07,59.26v7.19A10.05,10.05,0,0,1,33,66.21c4.26,2.18,7.86,2.18,11.47.29s5.61-2.23,10-.33a12.74,12.74,0,0,0,12.08.08c4.39-1.9,6.27-1.64,9.88.25V59.32C72.26,57.14,69.74,57.67,65.37,59.61Z",
    transform: "translate(-23.07 -19.12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.6,33a6.89,6.89,0,0,0,1.88.6,6.53,6.53,0,0,0,1.27.11h0A7,7,0,0,0,51,33.57a7.19,7.19,0,0,0,1.89-.6,7.28,7.28,0,0,0,3.8-4.4A7,7,0,0,0,57,26.4a7.28,7.28,0,0,0-14.56,0,7.83,7.83,0,0,0,.32,2.19A7.35,7.35,0,0,0,46.6,33Z",
    transform: "translate(-23.07 -19.12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.58,53.4c.39.18.77.35,1.17.56,2.69,1.39,7,1,10-.55h0l.06,0c3.86-2,6.1-1.63,10,0h0l.73.31a11.23,11.23,0,0,0,9.8,0l.73-.31h0l.58-.25V46.56a9.49,9.49,0,0,0-9.36-9.43H42.05a9.28,9.28,0,0,0-9,7.29,10.12,10.12,0,0,0-.27,2.15v6.49c.23.09.48.2.71.31Z",
    transform: "translate(-23.07 -19.12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.37,72.65a11.23,11.23,0,0,1-9.8,0c-4.36-2-6.61-2.48-10.78-.3-3,1.57-7.35,1.94-10,.55C30,70.43,27,70.26,23.07,72.28v7.2A10.05,10.05,0,0,1,33,79.24c4.26,2.18,7.86,2.18,11.47.28s5.61-2.22,10-.32a12.74,12.74,0,0,0,12.08.08c4.39-1.9,6.27-1.65,9.88.24V72.35C72.26,70.17,69.74,70.7,65.37,72.65Z",
    transform: "translate(-23.07 -19.12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJacz);
export default __webpack_public_path__ + "static/media/JACZ.c3926ed38d8ecad03c896dda70bbc46d.svg";
export { ForwardRef as ReactComponent };